import React from "react";
import ComingSoonContent from "../components/ComingSoon/ComingSoonContent";

const ComingSoon = () => {
  return (
    <>
      <ComingSoonContent />
    </>
  );
};

export default ComingSoon;
